//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconCalendar from "../../../images/icons/icon_calendar_full.svg";

class ToastNotification extends PolymerElement {
  static get template() {
    return html`
      <style>
      #toast {
        visibility: visible;
        max-width: 736px;
        margin: auto;
        color: #fff;
        border-radius: 8px;
        position: fixed;
        z-index: 150;
        left: 0;
        right: 0;
        top: 160px;
      }

      .content-container {
        padding: 16px;
        border-radius: 8px;
      }

      .success {
        -webkit-animation: fadein 2.0s;
        animation: fadein 2.0s;
        background-color: #007C41 !important;
      }

      .error {
        background-color: #D0021B !important;
      }

      .success .title-container {
        display: flex;
        align-items: center;
      }

      .success img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        float: left;
      }
      .success h2 {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        margin: 0;
      }
      .description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        color: #FFFFFF;
      }

      @-webkit-keyframes fadein {
        from {
          top: 0;
          opacity: 0;
        }
        to {
          top: 160px;
          opacity: 1;
        }
      }

      @keyframes fadein {
        from {
          top: -50px;
          opacity: 0;
        }
        to {
          top: 0px;
          opacity: 1;
        }
      }

      @-webkit-keyframes stay {
        from {
          min-width: 736px;
        }
        to {
          min-width: 736px;
        }
      }

      @keyframes stay {
        from {
          min-width: 736px;
        }
        to {
          min-width: 736px;
        }
      }

      @-webkit-keyframes fadeout {
        from {
          top: 160px;
          opacity: 1;
        }
        to {
          top: 0;
          opacity: 0;
        }
      }

      @keyframes fadeout {
        from {
          top: 160px;
          opacity: 1;
        }
        to {
          top: 0;
          opacity: 0;
        }
      }
        .show {
          display: block;
          
        }
        .hide {
          display: none;
        }

        /* Modal Content */
        .modal-content {
          width: 736px;
          height: auto;
          color: #FFFFFF;
          background-color: #007C41;
          padding: 16px;
          position: relative;
          z-index: 100;
          margin: 0 auto 0;
          /* 15% from the top and centered */
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
        }

        .header {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          margin: -15px 8px -15px;
        }
        .header img {
          width: 16px;
          height: 16px;
        }
        .content-link {
          display: flex;
          color: #FFFFFF;
          justify-content: flex-start;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          margin: 0px 8px;
        }
      </style>
      <div id="toast">
        <div class$="content-container [[handleModal(isActive)]]" on-click="handleCloseModal">
          <div class$="modal-content [[_checkErrorType(isError)]]">
            <template is="dom-if" if="[[!isError]]">
              <div class="header">
                <img src="[[iconCalendar]]" alt="alomedika"/>
                <h4>&nbsp Pendaftaran Berhasil</h4>
              </div>
            </template>
            <div class="content-link">
              <p class="description">{{title}} <strong>{{titleBold}}</strong></p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      iconCalendar: {
        type: String,
        value: iconCalendar,
      },    
      isActive: {
        type: Boolean,
        notify: true,
      },
      title: {
        type: String,
      },
      titleBold: {
        type: String,
      },
      isError: {
        type: Boolean,
        value: false,
      }
    };
  }

  handleCloseModal() {
    this.isActive = false;
  }

  handleModal(isActive) {
    setTimeout(() => {
      this.isActive = false;
    }, 5000);
    return isActive ? "show" : "hide";
  }

  _checkErrorType(isError) {
    return isError ? "error" : "success"
  }
}
customElements.define("toast-notification", ToastNotification);
